import { Monitor, Moon, Sun } from 'lucide-react';
import { de } from '@/i18n/de';
import { IconButton } from '@/shell/ui/button';
import type { ThemePreference } from './theme';
import { useTheme } from './theme-provider';

const OPTIONS: readonly { value: ThemePreference; label: string; Icon: typeof Sun }[] = [
  { value: 'light', label: de.theme.light, Icon: Sun },
  { value: 'dark', label: de.theme.dark, Icon: Moon },
  { value: 'system', label: de.theme.system, Icon: Monitor },
];

/** Umschalter Hell, Dunkel und „Wie System“; jede Option ist ein eigener, per Tastatur erreichbarer Knopf. */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();
  return (
    <fieldset className="m-0 inline-flex gap-1 border-0 p-0">
      <legend className="sr-only">{de.theme.legend}</legend>
      {OPTIONS.map(({ value, label, Icon }) => (
        <IconButton
          key={value}
          variant={preference === value ? 'secondary' : 'quiet'}
          aria-pressed={preference === value}
          aria-label={label}
          onClick={() => setPreference(value)}
        >
          <Icon aria-hidden="true" />
        </IconButton>
      ))}
    </fieldset>
  );
}
